import React, {useState} from "react";
import "./faqBlock.css";

const FaqBlock = ({ questions, answers }) => {
    const [visibleQuestion, setVisibleQuestion] = useState(null);

    const showQuestion = (index) => {
        setVisibleQuestion((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <div className="faq-block-container">
            <div className="faq-block-heading">
                <h2>Frequently Asked Questions</h2>
                <p>Have a question? We’re here to help!</p>
            </div>
            {questions.map((question, index) => (
                <div key={index} className="single-question">
                    <div className={`question-heading ${visibleQuestion === index ? "active" : ""}`} onClick={() => showQuestion(index)}>
                        <span>{question}</span>
                        <i className={`fa-solid fa-arrow-${visibleQuestion === index ? "up" : "down"}`}></i>
                    </div>
                    <div className="question-answer" style={{display: visibleQuestion === index ? "block" : "none"}}>
                        {Array.isArray(answers[index]) ? (
                            <ul>
                                {answers[index].map((point, pointIndex) => (
                                    <li key={pointIndex}>{point}</li>
                                ))}
                            </ul>
                        ) : (<>{answers[index]}</>)}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FaqBlock;
